export const TOUCH_TYPE = 'click';
// export const TOUCH_TYPE = 'touchstart';